import { forumBindAccount } from '@/api/activity.js';
const state = {
  forumAccount:''
};

const mutations = {
  CHANGE_FORUM_ACCOUNT:(state, value) => {
    state.forumAccount = value;
  },
};

const actions = {
  // 秒杀活动获取论坛账号
  async getForumBindAccount({commit, state}) {
    const r = await forumBindAccount();
    commit('CHANGE_FORUM_ACCOUNT', r.data.game_account);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
